import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "draivn-help-center-support-modal drv-mt-4" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "drv-text-heading-h4 drv-mb-3" }
const _hoisted_5 = { class: "drv-text-body-md drv-color-n700 drv-mb-4" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "info-support" }
const _hoisted_8 = { class: "title drv-my-2 drv-text-body-lg drv-text-weight-medium" }
const _hoisted_9 = { class: "description drv-mb-4 drv-text-body-md" }
const _hoisted_10 = {
  key: 0,
  class: "actions"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "actions row drv-mt-6" }
const _hoisted_13 = { class: "action" }
const _hoisted_14 = { class: "action cancel" }

import { computed, ref } from "vue";
import {
  EMessagesKeys,
  type ISupportInfo,
  type ISupportRequest,
} from "../../types";
import SupportForm from "./SupportForm.vue";
import { useDialogPluginComponent } from "draivn-ui-kit";


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportDialog',
  props: {
    value: {}
  },
  emits: [...useDialogPluginComponent.emits],
  setup(__props: any) {

const props = __props;



const supportModel = ref<ISupportRequest | null>(null);
const supportControl = ref<typeof SupportForm | null>(null);

const hasError = computed<boolean>(() => {
  return supportControl.value?.hasError ?? false;
});

const { dialogRef, onDialogCancel, onDialogOK, onDialogHide } =
  useDialogPluginComponent();

const onSubmit = () => {
  onDialogOK(supportModel.value);
};

return (_ctx: any,_cache: any) => {
  const _component_d_icon = _resolveComponent("d-icon")!
  const _component_d_btn = _resolveComponent("d-btn")!
  const _component_d_dialog = _resolveComponent("d-dialog")!

  return (_openBlock(), _createBlock(_component_d_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    "no-esc-dismiss": "",
    "no-backdrop-dismiss": "",
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_TITLE)), 1),
            _createVNode(_component_d_btn, { onClick: _unref(onDialogCancel) }, {
              default: _withCtx(() => [
                _createVNode(_component_d_icon, {
                  name: "cross",
                  size: 20,
                  color: "n900",
                  onClick: _unref(onDialogCancel)
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_SUBTITLE)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SupportForm, {
            class: "drv-mb-3",
            ref_key: "supportControl",
            ref: supportControl,
            modelValue: supportModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((supportModel).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_MESSAGE)), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_SUBTITLE)), 1),
            (_ctx.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "phone-link drv-mr-2",
                    href: `tel:${_ctx.value.phone}`,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, _toDisplayString(_ctx.value.phone), 9, _hoisted_11)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_d_btn, {
              label: _ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_SUBMIT_TITLE),
              onClick: onSubmit,
              disable: hasError.value
            }, null, 8, ["label", "disable"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_d_btn, {
              label: _ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_CANCEL_TITLE),
              onClick: _unref(onDialogCancel),
              variant: "secondary"
            }, null, 8, ["label", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})